<template>
  <div class="content-container">
    <a-form-model class="search-form" layout="inline" :model="searchForm">
      <a-form-model-item
        has-feedback
        :label="$t('table.advertisement.thead.name')"
        style="margin-bottom: 0px"
      >
        <a-input
          v-model="searchForm.name"
          :placeholder="$t('table.advertisement.thead.name')"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="search">{{
          $t(`actionTitles.submit`)
        }}</a-button>
      </a-form-model-item>
      <a-form-model-item layout="vertical">
        <a-button
          type="primary"
          :style="{ margin: '0px 15px' }"
          @click="addAdvertisement"
          >{{$t('actionTitles.add')}}</a-button
        >
      </a-form-model-item>
    </a-form-model>

    <div class="table-wrapper">
      <!-- <clear-selected
        alert-type="info"
        :show="selectedRowKeys.length>0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />-->

      <a-table
        :data-source="pageResult.data"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
        @change="handleTableChange"
      >
        <a-table-column
          key="id"
          :title="$t('table.advertisement.thead.id')"
          data-index="id"
          align="center"
        >
        </a-table-column>
        <a-table-column
          key="name"
          :title="$t('table.advertisement.thead.name')"
          data-index="name"
          align="center"
        />
        <a-table-column
          key="type"
          :title="$t('table.advertisement.thead.type')"
          data-index="type"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{ $t(`enum.advType.${record.type}`) }}</span>
          </template>
        </a-table-column>

        <a-table-column
          key="filesize"
          :title="$t('table.advertisement.thead.size')"
          data-index="filesize"
          align="center"
        />
        <a-table-column
          key="status"
          :title="$t('table.advertisement.thead.status')"
          data-index="status"
          align="center"
        >
          <template slot-scope="text, record">
            <!-- <span>{{$t(`enum.advStatus.${record.status}`)}}</span> -->
            <a-icon
              v-if="record.status == 0"
              @click="updateStatus(record)"
              style="color: red"
              type="close"
            />
            <a-icon
              v-else
              style="color: green"
              @click="updateStatus(record)"
              type="check"
            />
          </template>
        </a-table-column>
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click.stop="detail(record.id)">{{ $t(`actionTitles.edit`) }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                :cancelText="$t('actionTitles.cancel')"
                :okText="$t('actionTitles.confirm')"
                :title="$t('message.softDeleteHint')"
                @confirm="() => deleteInfo(record.id)"
              >
                <a href="javascript:;" style="color: red">{{
                  $t(`actionTitles.delete`)
                }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :title="modelTitle"
      :visible="exitVisible"
      @ok="save"
      @cancel="close"
      keyboard
    >
      <a-form-model
        ref="form"
        layout="vertical"
        :model="form"
        :rules="rules"
        :okText="$t('actionTitles.ascertain')"
        :cancelText="$t('actionTitles.cancel')"
      >
        <a-form-model-item
          :label="$t('form.advertisement.field.name.label')"
          prop="name"
        >
          <a-input
            v-model="form.name"
            :placeholder="$t('form.advertisement.field.name.placeholder')"
          />
        </a-form-model-item>
        <a-form-model-item
          :label="$t('form.advertisement.field.type.label')"
          ref="type"
          prop="type"
        >
          <a-select
            :placeholder="$t('form.advertisement.field.type.placeholder')"
            v-model="form.type"
          >
            <a-select-option :value="0">{{
              $t("enum.advType.0")
            }}</a-select-option>
            <a-select-option :value="1">{{
              $t("enum.advType.1")
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label="$t('form.advertisement.field.advertisement.label')"
        >
          <div style="height: 100%">
            <div style="margin-bottom: 5px; width: 400px" v-if="form.url">
              <img :src="form.url" width="100%" height="100%" alt="logo" />
            </div>
            <DragUploader ref="uploader" uptype="ads" :callback="getUploader">
              <a-spin
                :spinning="uploading"
                :tip="$t('message.uploading')"
                slot="body"
              >
                <a-button type="primary">{{
                  $t("message.uploadBtn")
                }}</a-button>
              </a-spin>
            </DragUploader>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import {
  pageQuery,
  save,
  deleteInfo,
  detail,
  updateStatus,
} from "@/api/homeBan";
import DragUploader from "@/components/DragUploader";

export default {
  components: {
    DragUploader,
  },
  data() {
    return {
      searchForm: {
        current_page: 1,
        per_page: 10,
        name: "",
        order: {},
        type: [], //0頂部廣告位 1中部廣告位
      },
      pageResult: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      modelTitle: "",
      form: {
        url: "",
        name: "",
      },
      exitVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: this.$t("form.advertisement.field.name.message"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("form.advertisement.field.type.message"),
            trigger: "change",
          },
        ],
      },
      uploading: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      let searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQuery(searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.pageResult = res.data;
            this.pagination.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      // if (Object.keys(filters).length > 0) {
      //   this.searchParam.status = filters.status;
      // }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";
        let order = {};
        order[field] = orderStr;
        this.searchParam.order = order;
      }
      this.loadData();
    },

    handleReset() {
      this.form = { url: "", name: "" };
      this.$refs.form.resetFields();
    },
    addAdvertisement() {
      this.modelTitle = this.$t("actionTitles.add");
      this.exitVisible = true;
      setTimeout(() => {
        this.handleReset();
      }, 0);
    },
    close(){
      this.exitVisible = false;
      this.$refs.form.resetFields();
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          save(this.form).then((res) => {
            this.$message.success(this.$t("message.saveSuccess"));
            this.exitVisible = false;
            this.loadData();
          });
        }
      });
    },

    detail(id) {
      // this.handleReset();
      this.modelTitle = this.$t("actionTitles.edit");
      detail({ id: id })
        .then((res) => {
          this.form = res.data;
          this.exitVisible = true;
        })
        .catch((err) => {});
    },
    updateStatus(record) {
      let param = { id: record.id };
      param.status = record.status == 1 ? 0 : 1;
      updateStatus(param).then((res) => {
        this.loadData();
      });
    },
    deleteInfo(id) {
      deleteInfo({ id: id })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.deleteSuccess"), 2, () => {
              this.loadData();
            });
          }
        })
        .catch((err) => {});
    },
    //回調方法，up為上傳實例對像
    getUploader: function (up) {
      let _this = this;
      _this.$nextTick(() => {
        up.bind("FilesAdded", function (up, file) {
          _this.uploading = true;
        });
        up.bind("Error", function (up, file) {
          _this.uploading = false;
        });
        up.bind("UploadComplete", function (up, file) {
          _this.uploading = false;
          _this.form.url = _this.$refs.uploader.fileList[0].url;
          if (_this.form.name == "") {
            _this.form.name = _this.$refs.uploader.fileList[0].name;
          }
          _this.form.filesize = _this.$refs.uploader.fileList[0].filesize;
        });
      });
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    }
  },
};
</script>
<style lang="less" scoped>
</style>
